import React, { useEffect, useRef, useState } from 'react'
import LanguageDropdown from '../../components/language/dropdown/DropDownLang'
import { useTranslation } from 'react-i18next';
import { textConvert } from '../../components/language/dropdown/textconvert';
import { useLocation } from 'react-router-dom';
import ImageCropper from '../../components/ImageCropper';
import { checkPhoneUser } from './Login';
import { useAuth } from '../../components/auth/UserContext';
import LoadCircle from '../../components/LoadCircle';
import OTPInput from 'react-otp-input';
import { createUserFirestore } from './RegisterCourse';
import clsx from 'clsx';

const logo = 'assets/images/banner/doonine_revB.png';
const text = 'assets/images/banner/doonine_text_2.png';

const defaultProfileImage = "https://firebasestorage.googleapis.com/v0/b/doonine-e9d64.appspot.com/o/default_img.jpg?alt=media&token=6ac97b40-4386-4539-9c93-739c8baa3742"

function RegisterPhone() {
    const { t } = useTranslation();
    const location = useLocation();
    const phoneState = location.state;
    const { phoneLogin } = useAuth();

    const [phone, setPhone] = useState(phoneState);
    const [name, setName] = useState('');
    const [role, setRole] = useState('');

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [verifyPage, setVerifyPage] = useState(false);
    const [otp, setOtp] = useState('');
    const confirmationRef = useRef(null);

    const [croppedModal, setCroppedModal] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const [profileImageChanged, setProfileImageChanged] = useState(null);
    const [profileImage, setProfileImage] = useState(null);

    const [timer, setTimer] = useState(0);
    const [isDisabled, setIsDisabled] = useState(true);
    const intervalRef = useRef(null);

    const showCoppedModal = () => setCroppedModal(true);
    const hideCroppedModal = () => setCroppedModal(false);

    function handleImage(e) {
        const file = e.target.files[0];
        if (file) {
            // console.log(file);
            setProfileImageChanged(URL.createObjectURL(file));
            // setProfileImage(file);
            showCoppedModal();
        }
    }

    const handleImageChange = (e) => {
        handleImage(e);
        // Reset the input value to allow selecting the same file again
        e.target.value = null;
    };

    const handleCroppedImage = (file, url) => {
        setCroppedImage(url);
        setProfileImage(file);
    };

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }

        const pattern = /^0\d{9}$/;

        try {
            setLoading(true);

            const p = document.getElementById('phone').value;
            const n = document.getElementById('name').value;
            const r = document.getElementById('role').value;

            setName(n);
            setRole(r);

            if (!pattern.test(p)) {
                setErrorMessage('invalid phone');
                document.getElementById('phone').focus();
                return;
            }

            const isExisted = await checkPhoneUser(p, setErrorMessage, true);

            if (typeof isExisted === 'boolean') {
                if (isExisted) {
                    return;
                }
            } else {
                setLoading(false);
                return;
            }

            startTimer();

            const isConfirm = await phoneLogin(p);
            if (isConfirm) {
                confirmationRef.current = isConfirm;
                setVerifyPage(true);
                setPhone(p);
            } else {
                confirmationRef.current = null;
                setVerifyPage(false);
                setPhone('');
            }
            setLoading(false);
            setErrorMessage('');

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    const handleResendOtp = async () => {
        setIsDisabled(true);
        await handleSubmit()
    };

    const handleVerify = async () => {

        setLoading(true);
        try {
            const result = await confirmationRef.current.confirm(otp);
            if (result) {
                await createUserFirestore(result.user.uid, setErrorMessage, defaultProfileImage, profileImage, name, phone, role);
                window.location.href = '/home'
            }
        } catch (error) {
            console.error('Failed to confirm verify code', error);
        }
        setLoading(false);
    }

    const startTimer = (seconds = 60) => {
        if (intervalRef.current) clearInterval(intervalRef.current); // Clear any existing timer
        setTimer(seconds);
        setIsDisabled(true);

        intervalRef.current = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    setIsDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        return () => clearInterval(intervalRef.current);
    }, []);

    return (
        <>
            <div className="main-wrap">
                <div className="nav-header bg-transparent shadow-none border-0 d-md-none d-block" style={{ backdropFilter: 'blur(2px)' }}>
                    <div className="nav-top w-100 d-flex justify-content-between">
                        <div className='log-container d-flex align-items-center'>
                            <img src={logo} alt='logo' width={55} />
                            <img src={text} alt='logo' width={130} />
                        </div>
                        <LanguageDropdown />
                    </div>
                </div>

                <div className="nav-header bg-transparent shadow-none border-0 d-none d-md-block">
                    <div className="nav-top w-100 d-flex justify-content-between">
                        <div className='log-container d-flex align-items-center p-2'>
                            <img src={logo} alt='logo' width={55} />
                            <img src={text} alt='logo' width={180} />
                        </div>
                        <LanguageDropdown />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-7 d-none d-xl-block p-0 vh-100 bg-image-cover bg-no-repeat"
                        style={{ backgroundImage: `url('assets/images/login/login_resized.jpg')` }}>
                    </div>
                    <div className="col-xl-5 vh-100 align-items-center d-flex bg-white theme-dark-bg rounded-3 overflow-hidden">
                        <div className="card shadow-none border-0 ms-auto me-auto login-card">
                            <div className="card-body rounded-0 text-left">
                                <h2 className="fw-700 display1-size display2-md-size mb-4 mt-3 text-center">
                                    {t(textConvert('Create your account'))}
                                </h2>

                                <div className={clsx('', { 'd-none': verifyPage })}>
                                    <div className="image-profile-container mb-3 text-center">
                                        <div className="image-profile text-center">
                                            <img
                                                src={croppedImage || defaultProfileImage}
                                                className="border border-2 p-1"
                                                alt="profile"
                                                style={{ objectFit: "cover", borderRadius: 20 }}
                                                width="160px"
                                                height="160px"
                                            />
                                            <input
                                                className="d-none"
                                                id="upload-img"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                        </div>
                                        <i
                                            className="feather-camera rounded-circle border border-2 p-2 bg-light shadow-lg"
                                            onClick={() =>
                                                document.getElementById("upload-img").click()
                                            }
                                            style={{ fontSize: 25 }}
                                        ></i>
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group mb-3">
                                            <label htmlFor="phone">{t(textConvert('phone'))}<span className="text-danger fs-5">*</span></label>
                                            <input type="tel" id='phone' className='form-control' defaultValue={phone} required />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label htmlFor="name">{t(textConvert('name-reg'))}<span className="text-danger fs-5">*</span></label>
                                            <input type="text" id='name' className='form-control' required />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label htmlFor="role">{t(textConvert('Role'))}<span className="text-danger fs-5">*</span></label>
                                            <select
                                                name="role"
                                                id="role"
                                                className="form-select"
                                                required
                                            >
                                                <option value="">{t(textConvert('no select'))}</option>
                                                <option value="player">{t(textConvert('Player'))}</option>
                                                <option value="caddie">{t(textConvert('Caddie'))}</option>
                                            </select>
                                        </div>

                                        <span className="text-danger">{t(textConvert(errorMessage))}</span>
                                        <button
                                            className="btn player-color text-white w-100 p-2 fs-3 d-flex align-items-center justify-content-center"
                                            id="register-button"
                                            style={{ minHeight: "3rem" }}
                                        >
                                            {loading ? (
                                                <LoadCircle size='sm' variant='light' />
                                            ) : (
                                                t(textConvert("Register"))
                                            )}
                                        </button>
                                    </form>
                                </div>

                                <div className={clsx('text-center', { 'd-none': !verifyPage })}>
                                    <h3 className='fw-600'>{t(textConvert('please enter your sms verify code'))}</h3>
                                    <div className='my-3'>
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={6}
                                            renderSeparator={<span className='mx-1'>-</span>}
                                            renderInput={(props) => <input {...props} />}
                                            inputStyle={'w-100 h-100 border-grey'}
                                            inputType='tel'
                                            containerStyle={{ height: 40 }}
                                        />
                                    </div>

                                    <div className='mb-2'>
                                        Not receive SMS?{" "}
                                        <span
                                            className={clsx('text-primary', {
                                                'pointer-events-none text-gray-400': isDisabled,
                                                'fw-600': !isDisabled,
                                                'pointer': !isDisabled
                                            })}
                                            onClick={!isDisabled ? handleResendOtp : undefined} // Only allow click if not disabled
                                        >
                                            {isDisabled ? `Resend (${timer})` : 'Resend'}
                                        </span>
                                    </div>


                                    <button className='btn btn-primary fs-3 p-2 w-50' onClick={() => handleVerify()}>
                                        {!loading ?
                                            t(textConvert('confirm'))
                                            :
                                            <LoadCircle size='sm' variant='light' />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <ImageCropper
                show={croppedModal}
                hide={hideCroppedModal}
                profileImage={profileImageChanged}
                croppedImage={handleCroppedImage}
            />
        </>
    )
}

export default RegisterPhone